import {DeviceType} from '@shared/cci/features/const/environment';

const MOBILE_MAX_WIDTH = 768 as const;
const TABLET_MAX_WIDTH = 1138 as const;

export default function getDeviceType() {
  if (window.innerWidth < MOBILE_MAX_WIDTH) {
    return DeviceType.MOBILE;
  }
  if (window.innerWidth < TABLET_MAX_WIDTH) {
    return DeviceType.TABLET;
  }
  return DeviceType.PC;
}
